import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "process-header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "ps-meta" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["href", "target"]
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { key: 7 }
const _hoisted_13 = { key: 8 }
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (_ctx.$store.state.user.logoPath)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.$store.state.apiUrl + _ctx.$store.state.spacesUrl + _ctx.$store.state.user.logoPath
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.$store.state.user.isAdmin)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['ps-meta-clip', { open: _ctx.expanded.location }]),
              title: _ctx.locationString,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded.location = !_ctx.expanded.location))
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "lbl" }, "Location", -1)),
              _createTextVNode(": " + _toDisplayString(_ctx.locationString), 1)
            ], 10, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.$store.state.user.isAdmin && _ctx.prevNodes.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "lbl" }, "Linked From", -1)),
              _cache[7] || (_cache[7] = _createTextVNode(": ", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prevNodes, (prevNode, i) => {
                return (_openBlock(), _createElementBlock("span", { key: i }, [
                  _cache[4] || (_cache[4] = _createTextVNode("  ", -1)),
                  _createElementVNode("a", {
                    href: '/playbook/' + prevNode.ThisSlug,
                    target: _ctx.linkTarget
                  }, _toDisplayString(prevNode.Name), 9, _hoisted_6),
                  _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.departmentsString)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(['ps-meta-clip', { open: _ctx.expanded.departments }]),
              title: _ctx.departmentsString,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expanded.departments = !_ctx.expanded.departments))
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "lbl" }, "Department", -1)),
              _createTextVNode(": " + _toDisplayString(_ctx.departmentsString), 1)
            ], 10, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.nodeTypesString)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(['ps-meta-clip', { open: _ctx.expanded.types }]),
              title: _ctx.nodeTypesString,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expanded.types = !_ctx.expanded.types))
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "lbl" }, "Type", -1)),
              _createTextVNode(": " + _toDisplayString(_ctx.nodeTypesString), 1)
            ], 10, _hoisted_8))
          : _createCommentVNode("", true),
        (_ctx.lastModified)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "lbl" }, "Last Modified", -1)),
              _createTextVNode(": " + _toDisplayString(_ctx.lastModified) + " V" + _toDisplayString(_ctx.node.Version), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.$store.state.user.isAdmin && _ctx.node.LastUpdatedBy)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "lbl" }, "Last Modified By", -1)),
              _createTextVNode(": " + _toDisplayString(_ctx.node.LastUpdatedBy), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.lastReviewed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "lbl" }, "Last Reviewed", -1)),
              _createTextVNode(": " + _toDisplayString(_ctx.lastReviewed), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.$store.state.user.isAdmin && _ctx.node.LastReviewedBy)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "lbl" }, "Last Reviewed By", -1)),
              _createTextVNode(": " + _toDisplayString(_ctx.node.LastReviewedBy), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.files.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "lbl" }, "Files", -1)),
              _cache[15] || (_cache[15] = _createTextVNode(": ", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, i) => {
                return (_openBlock(), _createElementBlock("span", { key: i }, [
                  _createElementVNode("a", {
                    href: _ctx.$store.state.apiUrl + _ctx.$store.state.spacesUrl + file.SpacesPath,
                    target: "_blank"
                  }, _toDisplayString(file.Name), 9, _hoisted_14),
                  (i < _ctx.files.length - 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, ", "))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}